module.exports = __webpack_public_path__ + "img/p2p.aefa7b8b.png";